<template>
  <div name="molecule-service-detail" class="server-detail-card">
    <div class="card__header card-padding-top card-padding-x">
      <span class="card__header--topic">Service Detail</span>
    </div>
    <div class="row card-padding-x">
      <div class="col-12 col-md-6">
        <atom-select
          v-model="mappedContractData.generalServiceInfo.site"
          title="NTDC Site"
          placeholder="Select NTDC Site"
          label="siteName"
          :isAsterisk="true"
          :isClearable="false"
          :isAppendToBody="false"
          :isEnableProper="false"
          :isError="isErrorAtSelectSite"
          :errorMessage="errorMessageAtSelector"
          :option="siteOption"
          :isDisable="checkDisableInput(contractId)"
        ></atom-select>
      </div>
      <div class="col-12 col-md-6 mt-1 mt-md-0">
        <atom-datepicker
          v-model="mappedContractData.generalServiceInfo.contractStartDate"
          datepickerId="selectContractStartDate"
          title="Contract Start Date"
          placeholder="Contract Start Date"
          type="dateNtime"
          :isAsterisk="true"
          :isError="isErrorAtSelectContractStartDate"
          :errorMessage="errorMessageAtSelector"
          :isDisabled="checkDisableInput()"
        >
        </atom-datepicker>
      </div>
    </div>
    <hr class="mt-2" />
    <div
      v-for="(packageItem, index) in mappedContractData.packages"
      :key="index"
      class="service-detail-info card-padding-x card-padding-bottom"
    >
      <div
        :ref="`scrollToElement_${index}`"
        class="d-flex align-items-center mt-2"
      >
        <span class="text-semibold-primary text-uppercase">
          Service #{{ index + 1 }}
        </span>
        <atom-button
          v-if="
            index === mappedContractData.packages.length - 1 &&
            !checkDisableInput()
          "
          buttonId="add-new-service"
          buttonSize="sm"
          class="pl-1"
          @click="clickAddNewService"
        >
          <feather-icon icon="PlusIcon" size="14" />
        </atom-button>
        <b-dropdown
          v-if="mappedContractData.packages.length > 1 && !checkDisableInput()"
          no-caret
          right
          v-ripple.400="'rgba(30, 30, 30, 0.15)'"
          text="Dark"
          variant="flat-dark"
          size="sm"
          class="custom-margin-left-6"
        >
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon"></feather-icon>
          </template>
          <b-dropdown-item @click="clickDeleteService(index)">
            <div class="d-flex align-items-center text-color-danger">
              <feather-icon icon="Trash2Icon" class="mr-1"></feather-icon>
              <span class="custom-padding-top">Delete</span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mt-1">
          <atom-select
            v-model="packageItem.service"
            title="Service"
            placeholder="Select Service"
            label="serviceName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :errorMessage="errorMessageAtSelector"
            :option="serviceOption"
            :isDisable="checkDisableInput()"
            :isError="checkErrorInput(isEmptyObject(packageItem.service))"
          ></atom-select>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <atom-datepicker
            v-model="packageItem.startDate"
            datepickerId="selectContractStartDate"
            title="Service Start Date"
            placeholder="Service Start Date"
            type="dateNtime"
            :isAsterisk="true"
            :errorMessage="errorMessageAtSelector"
            :isDisabled="checkDisableInput()"
            :isError="checkErrorInput(isEmptyString(packageItem.startDate))"
          >
          </atom-datepicker>
        </div>
        <div class="col-12 col-md-10 mt-1">
          <atom-select
            v-model="packageItem.package"
            title="Package"
            placeholder="Select Package"
            label="packageName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :errorMessage="errorMessageAtSelector"
            :option="packageItem.packageDropdownOption"
            :isDisable="checkDisableInput(!packageItem.service)"
            :isError="checkErrorInput(isEmptyObject(packageItem.package))"
          ></atom-select>
        </div>
        <div class="col-12 col-md-2 mt-1">
          <atom-input
            v-model="packageItem.packageQuantity"
            title="Quantity"
            placeholder="Quantity"
            errorMessage="Invalid"
            :isAsterisk="true"
            :isDisable="checkDisableInput(!packageItem.package)"
            :isError="
              checkErrorInput(isNotNumeric(packageItem.packageQuantity))
            "
          ></atom-input>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <atom-select
            v-model="packageItem.packagePeriod"
            title="Contract Period"
            placeholder="Select Contract Period"
            label="packagePeriodName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :errorMessage="errorMessageAtSelector"
            :option="packageItem.packagePeriodOption"
            :isDisable="checkDisableInput(!packageItem.package)"
            :isError="checkErrorInput(isEmptyObject(packageItem.packagePeriod))"
          ></atom-select>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <atom-select
            v-model="packageItem.location"
            title="Location"
            placeholder="Select Location"
            label="locationName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :errorMessage="errorMessageAtSelector"
            :option="locationOption"
            :isDisable="
              checkDisableInput(!mappedContractData.generalServiceInfo.site)
            "
            :isError="checkErrorInput(isEmptyObject(packageItem.location))"
          ></atom-select>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <atom-input
            v-model="packageItem.bundleNetwork"
            title="Bundle Network"
            placeholder="Bundle Network"
            :isDisable="checkDisableInput()"
          ></atom-input>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <atom-input
            v-model="packageItem.domain"
            title="Domain"
            placeholder="Domain"
            :isDisable="checkDisableInput()"
          ></atom-input>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <template v-if="isShowRack">
            <div class="custom-title--font">Rack</div>

            <div
              v-if="
                packageItem.rack &&
                !packageItem.rack.length &&
                checkDisableInput()
              "
              class="d-flex justify-content-center text-color-grey"
            >
              This Contract has no Rack Data
            </div>

            <div
              v-if="packageItem.rack && !!packageItem.rack.length"
              class="content-overflow-scroll"
            >
              <div
                v-for="(rack, rackIndex) in packageItem.rack"
                :key="rackIndex"
                class="rack-item border rounded p-1"
              >
                <div class="rack-name" @click="gotoOceanRack(rack.rackId)">
                  {{ rack.name }}
                </div>
                <div v-if="rack.description">{{ rack.description }}</div>
                <div>
                  Location:
                  {{
                    `${rack.building.name}, ${rack.floor.name}, ${rack.room.name}`
                  }}
                </div>
              </div>
            </div>
            <div v-if="!checkDisableInput()" class="button-wrapper">
              <div
                class="button-dash box-dashed custom-add-item-btn mt-1"
                @click="onClickAddNewRackButton"
              >
                <feather-icon
                  class="icon-size-24px text-primary"
                  icon="PlusCircleIcon"
                ></feather-icon>
                <label class="button--text">Add New Rack</label>
              </div>
            </div>
          </template>
        </div>
        <div class="col-12 col-md-6 mt-1">
          <atom-text-area
            v-model="packageItem.serviceNote"
            title="Service Note"
            placeholder="Note"
            :isDisable="checkDisableInput()"
            :rows="8"
          ></atom-text-area>
        </div>
      </div>

      <hr v-if="packageItem.serviceInfo && packageItem.serviceInfo.length" />
      <div v-if="packageItem.serviceInfo && packageItem.serviceInfo.length">
        <span class="text--topic-medium">Service Information</span>
        <div class="row">
          <div
            v-for="(service, index) in packageItem.serviceInfo"
            :key="index"
            class="my-1 col-12 col-md-6"
          >
            <span class="font-weight-bold">{{ service.packageItemName }}</span>
            <ul
              v-if="service.packageSubItem && service.packageSubItem.length"
              class="pl-2"
            >
              <li
                v-for="(subitem, index) in service.packageSubItem"
                :key="index"
              >
                {{ subitem }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        v-if="packageItem.packageOptions && packageItem.packageOptions.length"
        name="package-option-container"
      >
        <hr />
        <div name="optional-package-container" class="row mt-2 mb-1">
          <span class="col-12 text--topic-medium">ADD-ON PACKAGE</span>
        </div>
        <div class="row card-padding-bottom">
          <div class="col-12 col-lg-8">
            <div
              v-for="option in packageItem.packageOptions"
              :key="option.optionId"
              class="mb-1 row d-flex align-items-center custom-line-height"
            >
              <div class="col-8 col-md-6">
                <span>{{ option.optionName }}</span>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <b-form-spinbutton
                  id="sb-inline"
                  size="sm"
                  min="0"
                  v-model="option.quantity"
                  inline
                  :disabled="checkDisableInput()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div
      class="card-padding-x custom-hover-effect pb-2 width-fit-content"
      v-b-toggle.technical-info
      @click="rotateChevron"
    >
      <span>Technical Information</span>
      <feather-icon
        ref="chevron"
        icon="ChevronDownIcon"
        size="14"
        class="custom-margin-left-8"
      />
    </div>
    <b-collapse id="technical-info" visible>
      <div class="technical-information card-padding-x card-padding-bottom row">
        <div v-if="contractId" class="col-12 col-md-6">
          <span
            v-if="
              checkDisableInput() &&
              !mappedContractData.generalServiceInfo.ipAddresses.length
            "
            class="block font-size-12"
          >
            No IP Address
          </span>
          <div v-else class="d-flex font-size-12">
            <b-badge pill variant="light-primary" class="badge--style">
              {{
                mappedContractData.generalServiceInfo.ipAddresses.length || 0
              }}
            </b-badge>
            <span>IP Address</span>
          </div>
          <div
            v-if="!!mappedContractData.generalServiceInfo.ipAddresses"
            class="content-overflow-scroll"
          >
            <atom-item-list
              v-for="(ip, index) in mappedContractData.generalServiceInfo
                .ipAddresses"
              :key="index"
              textVariant="text-color-black"
              :item="ip || '-'"
              :showLinkIcon="false"
              :isEnableHoverEffect="false"
              :isEnableDeleteItem="false"
            ></atom-item-list>
          </div>
          <div
            v-if="!checkDisableInput()"
            class="custom-add-item-btn mt-1"
            @click="clickGoToIpam"
          >
            <span class="font-size-12"> Go to IPAM </span>
          </div>
        </div>
        <div class="col-12 col-md-6 mt-1 mt-md-0">
          <atom-text-area
            v-model="mappedContractData.generalServiceInfo.otherTechnicalDetail"
            title="Other Technical Detail"
            placeholder="Other Technical Detail"
            :rows="8"
            :isDisable="checkDisableInput()"
          ></atom-text-area>
        </div>
      </div>
    </b-collapse>
    <!-- Package Detail -->
  </div>
</template>

<script>
import {
  BCollapse,
  BFormSpinbutton,
  VBToggle,
  BDropdown,
  BDropdownItem,
  BBadge,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import debounce from "lodash/debounce"

import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomItemList from "@/components/atoms/AtomItemList.vue"
import mixinsValidators from "@/mixins/mixinsValidator"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import { mapGetters } from "vuex"

import { OCEAN_URL } from "@/constants"

export default {
  name: "MoleculeServiceDetail",
  components: {
    BBadge,
    BCollapse,
    BFormSpinbutton,
    BDropdown,
    BDropdownItem,
    AtomButton,
    AtomCheckbox,
    AtomSelect,
    AtomInput,
    AtomDatepicker,
    AtomTextArea,
    AtomItemList
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple
  },
  props: {
    contractStatus: {
      type: String,
      required: false,
      default: null
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false
    },
    serviceOption: {
      type: Array,
      required: true
    },
    locationOption: {
      type: Array,
      required: true
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    funcGetPackageNameList: {
      type: Function,
      required: true,
      default: () => {}
    },
    funcGetServiceAndPackageDetail: {
      type: Function,
      required: true,
      default: () => {}
    },
    value: {
      type: Object,
      required: false,
      default: null
    },
    isShowRack: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mixins: [mixinsValidators, mixinsSiteHelper, mixinsObjectHelper],
  emits: [
    "input",
    "onUpdateGeneralServiceInfo",
    "onUpdateContractPackages",
    "onUpdateError",
    "onClickGoToIpam",
  ],
  data() {
    return {
      oceanUrl: OCEAN_URL,

      errorMessageAtInput: "Please enter valid data",
      errorMessageAtSelector: "Please select data",
      mappedContractData: {
        generalServiceInfo: {
          site: null,
          contractStartDate: null,
          ipAddresses: [],
          otherTechnicalDetail: "",
        },
        packages: [
          {
            service: null,
            package: null,
            packageQuantity: null,
            packagePeriod: null,
            location: null,
            bundleNetwork: "",
            domain: "",
            rack: [],
            serviceNote: "",
            startDate: null,
            packageOptions: [],
            packageDropdownOption: [],
            packagePeriodOption: [],
            serviceInfo: [],
          },
        ],
      },
      siteOption: [],
      bufferAllServiceOption: [],
      isValidateNewRack: false,
      newRack: "",
      newService: {
        service: null,
        package: null,
        packageQuantity: null,
        packagePeriod: null,
        location: null,
        bundleNetwork: "",
        domain: "",
        rack: [],
        serviceNote: "",
        startDate: null,
        packageOptions: [],
        packageDropdownOption: [],
        packagePeriodOption: [],
        serviceInfo: [],
      },
    }
  },

  computed: {
    ...mapGetters("siteStore", ["siteSetting", "siteOptions"]),

    propContractDetail: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    generalServiceInfoForWatch() {
      return this.deepCopyObject(this.mappedContractData.generalServiceInfo)
    },

    packagesForWatch() {
      return this.deepCopyObject(this.mappedContractData.packages)
    },

    contractId() {
      return this.$route?.params?.id
    },

    isContractInDeletedStatus() {
      return this.propContractDetail.status?.toLowerCase() === "deleted"
    },

    isErrorAtSelectSite() {
      return this.isValidateTrigger
        ? this.isEmptyObject(this.mappedContractData.generalServiceInfo.site)
        : false
    },

    isErrorAtSelectContractStartDate() {
      return this.isValidateTrigger
        ? this.isEmptyString(
            this.mappedContractData.generalServiceInfo.contractStartDate
          )
        : false
    },

    isErrorNewRack() {
      return this.isValidateNewRack ? this.isEmptyString(this.newRack) : false
    },

    isErrorAtPackages() {
      const contract = this.mappedContractData.packages
      const isErrorAtSelectService = contract.some((item) =>
        this.isEmptyObject(item.service)
      )
      const isErrorAtServiceStartDate = contract.some((item) =>
        this.isEmptyString(item.startDate)
      )
      const isErrorAtSelectPackage = contract.some((item) =>
        this.isEmptyObject(item.package)
      )
      const isErrorAtQuantity = contract.some((item) =>
        this.isNotNumeric(item.packageQuantity)
      )
      const isErrorAtSelectPeriod = contract.some((item) =>
        this.isEmptyObject(item.packagePeriod)
      )
      const isErrorAtLocation = contract.some((item) => {
        this.isEmptyObject(item.location)
      })

      return (
        isErrorAtSelectService ||
        isErrorAtServiceStartDate ||
        isErrorAtSelectPackage ||
        isErrorAtQuantity ||
        isErrorAtSelectPeriod ||
        isErrorAtLocation
      )
    },

    isErrorOccur() {
      return (
        this.isErrorAtSelectSite ||
        this.isErrorAtSelectContractStartDate ||
        this.isErrorAtPackages
      )
    },
  },

  watch: {
    siteSetting() {
      this.getSiteOption()
      this.mappedContractData.generalServiceInfo.site = null
    },

    propContractDetail: {
      deep: true,
      async handler(newValue, oldValue) {
        if (this.compareIsChangeObject(newValue, oldValue)) {
          await this.mapContractData()
        }
      },
    },

    generalServiceInfoForWatch: {
      deep: true,
      handler(newValue, oldValue) {
        if (this.compareIsChangeObject(newValue, oldValue)) {
          this.$emit("onUpdateGeneralServiceInfo", newValue)
        }
      },
    },

    packagesForWatch: {
      deep: true,
      handler(newValue, oldValue) {
        if (this.compareIsChangeObject(newValue, oldValue)) {
          if (newValue.length === oldValue.length) {
            // In case of the same service set (not delete any service)
            const targetIndex = this.findIndexChangedObjects(newValue, oldValue)
            let oldTargetPackage = oldValue[targetIndex]
            let targetPackage = newValue[targetIndex]

            if (
              this.checkConditionEmitWithDebounce(
                oldTargetPackage,
                targetPackage
              )
            ) {
              // debounce to prevent a wrong check-change-process from lots of emit event
              this.emitUpdateWithDebounce(newValue)
            } else {
              // need hot update with service and package data to fetch option from api
              if (
                this.checkConditionIsServiceChange(
                  oldTargetPackage,
                  targetPackage
                )
              ) {
                targetPackage.package = null
                targetPackage.packageOptions = []
              }
              if (
                this.checkConditionIsPackageChange(
                  oldTargetPackage,
                  targetPackage
                )
              ) {
                targetPackage.packageQuantity = null
                targetPackage.packagePeriod = null
              }
              this.$emit("onUpdateContractPackages", newValue)
            }
          } else {
            // In case of add new or delete service
            this.$emit("onUpdateContractPackages", newValue)
          }
        }
      },
    },

    "mappedContractData.generalServiceInfo.site": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          if (oldValue) {
            this.mappedContractData.packages.forEach((item) => {
              item.location = null
            })
          }
          const updatedContractPackages = this.mappedContractData.packages
          const selectedSite = this.mappedContractData.generalServiceInfo.site
          this.$emit("onSelectSite", selectedSite, updatedContractPackages)
        }
      },
    },

    isErrorOccur: {
      immediate: true,
      handler() {
        this.$emit("onUpdateError", this.isErrorOccur)
      },
    },
  },

  mounted() {
    this.getSiteOption()
  },

  methods: {
    getSiteOption() {
      this.siteOption = this.siteOptions.map((site) => {
        return {
          siteId: site.value,
          siteName: site.text,
        }
      })
    },

    async mapContractData() {
      this.mapGeneralServiceInfo()
      await this.mapPackages()
    },

    mapGeneralServiceInfo() {
      const generalServiceInfo = this.propContractDetail.generalServiceInfo
      this.mappedContractData.generalServiceInfo = {
        site: this.getSiteFromId(generalServiceInfo?.siteId),
        contractStartDate: generalServiceInfo.contractStartDate,
        ipAddresses: generalServiceInfo.ipAddresses,
        otherTechnicalDetail: generalServiceInfo.otherTechnicalDetail,
      }
    },

    getSiteFromId(siteId) {
      return siteId
        ? this.siteOption.find((site) => site?.siteId === siteId)
        : null
    },

    async mapPackages() {
      const packages = this.propContractDetail.packages
      this.mappedContractData.packages = await Promise.all(
        packages.map(async (item) => {
          const {
            packageDropdownOption,
            packagePeriodOption,
            serviceInfo,
            packageOptionsFromApi,
          } = await this.getOrFetchOptionFromApi(item)

          return {
            service: this.getServiceFromId(item.serviceId),
            package: this.getPackageFromId(
              packageDropdownOption,
              item.packageId
            ),
            packageQuantity: item.packageQuantity,
            packagePeriod: this.getPackagePeriodFromId(
              packagePeriodOption,
              item.packagePeriodId
            ),
            location: this.getLocationFromId(item.locationId),
            bundleNetwork: item.bundleNetwork,
            contractPackageId: item.contractPackageId,
            domain: item.domain,
            rack: item.rack,
            serviceNote: item.serviceNote,
            startDate: item.startDate,
            packageOptions: this.decoratePackageOptions(
              item.packageOptions,
              packageOptionsFromApi
            ),
            packageDropdownOption,
            packagePeriodOption,
            serviceInfo,
          }
        })
      )
    },

    async getOrFetchOptionFromApi(item) {
      const existingBufferValue = this.bufferAllServiceOption.find(
        (buffer) =>
          buffer?.serviceId === item?.serviceId &&
          buffer?.packageId === item?.packageId
      )

      if (existingBufferValue) {
        return { ...existingBufferValue }
      }

      const {
        packageDropdownOption,
        packagePeriodOption,
        serviceInfo,
        packageOptionsFromApi,
      } = await this.getOptionFromApi(item)

      this.bufferAllServiceOption.push({
        serviceId: item.serviceId,
        packageId: item.packageId,
        packageDropdownOption,
        packagePeriodOption,
        serviceInfo,
        packageOptionsFromApi,
      })

      return {
        packageDropdownOption,
        packagePeriodOption,
        serviceInfo,
        packageOptionsFromApi,
      }
    },

    async getOptionFromApi(item) {
      let packageDropdownOption = []
      let packagePeriodOption = []
      let serviceInfo = []
      let packageOptionsFromApi = []
      if (item.serviceId) {
        packageDropdownOption = await this.getPackageDropdownOptionFromApi(
          item.serviceId
        )

        if (item.packageId) {
          const response = await this.getPeriodAndServiceInfoAndAddon(
            item.serviceId,
            item.packageId
          )

          packagePeriodOption = response.packagePeriodOption
          serviceInfo = response.serviceInfo
          packageOptionsFromApi = response.packageOptions

          const newBufferValue = {
            serviceId: item.serviceId,
            packageId: item.packageId,
            packageDropdownOption,
            packagePeriodOption,
            serviceInfo,
            packageOptionsFromApi,
          }

          this.bufferAllServiceOption.push(newBufferValue)

          // Check for duplicates after push and remove them
          this.bufferAllServiceOption = this.removeDuplicateBufferValues()
        }
      }

      return {
        packageDropdownOption,
        packagePeriodOption,
        serviceInfo,
        packageOptionsFromApi,
      }
    },

    removeDuplicateBufferValues() {
      return this.bufferAllServiceOption
        .filter((buffer) => buffer.packageId !== undefined) // Remove entries with undefined packageId
        .filter(
          (buffer, index, self) =>
            index ===
            self.findIndex(
              (b) =>
                b.packageId === buffer.packageId &&
                b.serviceId === buffer.serviceId
            )
        )
    },

    getServiceFromId(serviceId) {
      return serviceId
        ? this.serviceOption.find((service) => service.serviceId === serviceId)
        : null
    },

    getPackageFromId(packageList, packageId) {
      return packageId
        ? packageList.find((packageItem) => packageItem.packageId === packageId)
        : null
    },

    getPackagePeriodFromId(periodList, periodId) {
      return periodId
        ? periodList.find((period) => period.packagePeriodId === periodId)
        : null
    },

    getLocationFromId(locationId) {
      return locationId
        ? this.locationOption.find(
            (location) => location.locationId === locationId
          )
        : null
    },

    decoratePackageOptions(packageOptions, packageOptionsFromApi) {
      return packageOptions.length
        ? packageOptions.map((item) => {
            return {
              optionId: item.optionId,
              optionName: item.optionName,
              price: item.price,
              quantity: item.quantity,
            }
          })
        : packageOptionsFromApi.map((item) => {
            return {
              optionId: item.packageOptionId,
              optionName: item.packageOptionName,
              price: item.price,
              quantity: 0,
            }
          })
    },

    async getPackageDropdownOptionFromApi(serviceId) {
      const response = await this.funcGetPackageNameList(serviceId)
      return response.data
    },

    async getPeriodAndServiceInfoAndAddon(serviceId, packageId) {
      const response = await this.funcGetServiceAndPackageDetail(
        serviceId,
        packageId
      )
      const packagePeriodOption = response.data.periods
      const serviceInfo = response.data.details
      const packageOptions = response.data.options
      return { packagePeriodOption, serviceInfo, packageOptions }
    },

    checkConditionEmitWithDebounce(oldTargetPackage, targetPackage) {
      const hasServiceValueBeforeChange = oldTargetPackage.service?.serviceId
      const hasPackageValueBeforeChange = oldTargetPackage.package?.packageId
      const isSameSelectedService = this.compareIsSameObject(
        targetPackage.service,
        oldTargetPackage.service
      )
      const isSameSelectedPackage = this.compareIsSameObject(
        oldTargetPackage.package,
        targetPackage.package
      )
      const isSamePackageOptionInDropdown = this.compareIsSameObject(
        oldTargetPackage.packageDropdownOption,
        targetPackage.packageDropdownOption
      )
      const isSamePackagePeriodOption = this.compareIsSameObject(
        oldTargetPackage.packagePeriodOption,
        targetPackage.packagePeriodOption
      )
      const isSameServiceInfo = this.compareIsSameObject(
        oldTargetPackage.serviceInfo,
        targetPackage.serviceInfo
      )
      const isSamePackageOptions = this.compareIsSameObject(
        oldTargetPackage.packageOptions,
        targetPackage.packageOptions
      )

      return (
        hasServiceValueBeforeChange &&
        hasPackageValueBeforeChange &&
        isSameSelectedService &&
        isSameSelectedPackage &&
        isSamePackageOptionInDropdown &&
        isSamePackagePeriodOption &&
        isSameServiceInfo &&
        isSamePackageOptions
      )
    },

    checkConditionIsServiceChange(oldTargetPackage, targetPackage) {
      return oldTargetPackage?.service?.serviceId
        ? this.compareIsChangeObject(
            targetPackage.service,
            oldTargetPackage.service
          )
        : false
    },

    checkConditionIsPackageChange(oldTargetPackage, targetPackage) {
      return oldTargetPackage?.package?.packageId
        ? this.compareIsChangeObject(
            targetPackage.package,
            oldTargetPackage.package
          )
        : false
    },

    // debounce emit because prevent error from lots of change
    emitUpdateWithDebounce: debounce(function (newValue) {
      this.$emit("onUpdateContractPackages", newValue)
    }, 800),

    findIndexChangedObjects(newArray, oldArray) {
      let targetIndex = -1
      for (let i = 0; i < newArray.length; i++) {
        const newObj = newArray[i]
        const oldObj = oldArray[i]
        if (this.compareIsChangeArray(newObj, oldObj)) {
          targetIndex = i
        }
      }
      return targetIndex
    },

    checkDisableInput(condition = false) {
      const booleanCondition = Boolean(condition)
      return (
        !this.hasEditPermission ||
        this.isContractInDeletedStatus ||
        booleanCondition
      )
    },

    checkErrorInput(condition = false) {
      const booleanCondition = Boolean(condition)
      return this.isValidateTrigger ? booleanCondition : false
    },

    clickGoToIpam() {
      this.$emit("onClickGoToIpam")
    },

    onClickDeleteRack(currentPackage, targetRack) {
      const targetIndex = currentPackage.rack.findIndex(
        (item) => item === targetRack
      )
      if (targetIndex > -1) {
        currentPackage.rack.splice(targetIndex, 1)
      }
    },

    onClickAddNewRackButton() {
      window.open(`${this.oceanUrl}/rack`, "_blank")
    },

    clickAddNewService() {
      this.mappedContractData.packages.push(this.newService)
      this.scrollToTargetService(this.mappedContractData.packages.length - 1)
    },

    clickDeleteService(index) {
      this.mappedContractData.packages.splice(index, 1)
      this.scrollToTargetService(index)
    },

    scrollToTargetService(targetServiceIndex) {
      this.$nextTick(() => {
        // calculate scroll position to prevent scroll to undefined target (in case delete the last one)
        const targetIndex =
          targetServiceIndex === this.mappedContractData.packages.length
            ? this.mappedContractData.packages.length - 1
            : targetServiceIndex
        const targetPosition = `scrollToElement_${targetIndex}`
        const elementArray = this.$refs[targetPosition]
        if (elementArray && elementArray.length > 0) {
          const element = elementArray[0]
          // Calculate the target position manually
          const targetOffset = element.offsetTop - 110
          // Scroll to the calculated position
          window.scrollTo({ top: targetOffset, behavior: "smooth" })
        }
      })
    },

    rotateChevron() {
      let rotateUp = this.$refs.chevron.classList.contains("chevron-up")
      let rotateDown = this.$refs.chevron.classList.contains("chevron-down")
      if (!rotateUp && !rotateDown) {
        this.$refs.chevron.classList.add("chevron-up")
      } else if (rotateUp) {
        this.$refs.chevron.classList.remove("chevron-up")
        this.$refs.chevron.classList.add("chevron-down")
      } else {
        this.$refs.chevron.classList.remove("chevron-down")
        this.$refs.chevron.classList.add("chevron-up")
      }
    },

    gotoOceanRack(rackId) {
      window.open(`${this.oceanUrl}/rack/${rackId}`, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.card__header {
  margin-bottom: 14px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}

.card-padding {
  padding: 21px;
}

.card-padding-x {
  padding-left: 21px;
  padding-right: 21px;
}

.card-padding-y {
  padding-top: 21px;
  padding-bottom: 21px;
}

.card-padding-top {
  padding-top: 21px;
}

.card-padding-bottom {
  padding-bottom: 21px;
}

.text--topic-medium {
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  color: #b9b9c3;
}

.text--description {
  font-weight: 300;
  font-size: 12px;
}

.price--padding-custom {
  padding-top: 5px;
  padding-left: 24px;
}

.custom-padding-left-8 {
  padding-left: 8px;
}

.custom-margin-left-8 {
  margin-left: 8px;
}

.custom-hover-effect {
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #7367f0;
  }
}

.custom-hover-pointer:hover {
  cursor: pointer;
}

.custom-border-bottom {
  border-bottom: 1px solid #ebe9f1;
}

.custom-padding-x {
  padding: 8px 0;
}

.custom-add-ip-btn {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  color: #b9b9c3;
  border: 1px dashed #b9b9c3;
  border-radius: 5px;
  &:hover {
    cursor: pointer;
    color: #7367f0;
    border-color: #7367f0;
  }
}

.width-fit-content {
  width: fit-content;
}

li:not(:last-child) {
  margin-bottom: 6px;
}

.chevron-down {
  transition: transform 0.2s ease-in-out;
  transform: rotate(0deg);
}

.chevron-up {
  transition: transform 0.2s ease-in-out;
  transform: rotate(180deg);
}

.custom-add-item-btn {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  color: #b9b9c3;
  border: 1px dashed #b9b9c3;
  border-radius: 5px;
  &:hover {
    cursor: pointer;
    color: #7367f0;
    border-color: #7367f0;
  }
}

.custom-title--font {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.button-dash {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rack-name {
  color: #5e5873;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.rack-item {
  margin-bottom: 0.5rem;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 5px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.content-overflow-scroll {
  max-height: 200px;
  overflow-y: auto;
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
}
</style>
